import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsArray, IsBoolean, IsISO8601, IsEnum, IsObject, IsString } from 'class-validator';
import { OrderStatusEnum } from '../enum';
export class ListOrderRequestDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, description: 'List of order.uuid', example: ['2f29ac39-df26-44ed-8787-87dbfcd895e4'] }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Array)
], ListOrderRequestDto.prototype, "ids", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'List of merchant.uuid', example: '9516bb3b-c4a2-4325-8916-401d4388c5f6' }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", String)
], ListOrderRequestDto.prototype, "merchantId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, description: 'List of store.uuid', example: ['d3799df2-825f-45a0-a447-befebb0afbdd'] }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Array)
], ListOrderRequestDto.prototype, "storeIds", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, description: 'List of user.userId', example: ['000043261882211'] }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Array)
], ListOrderRequestDto.prototype, "userIds", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, description: 'List of order.orderNumber', example: ['96OPD7', 'TGGL53'] }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Array)
], ListOrderRequestDto.prototype, "orderNumbers", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, description: 'List of order.status', example: ['new'] }),
    IsArray({ always: true }),
    IsEnum(OrderStatusEnum, { each: true, always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Array)
], ListOrderRequestDto.prototype, "statuses", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'ASAP/delayed orders' }),
    IsBoolean({ always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Boolean)
], ListOrderRequestDto.prototype, "isASAP", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Recipient full name', example: 'John Doe' }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", String)
], ListOrderRequestDto.prototype, "recipientName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date, description: 'Orders later than date (UTC date)', example: '2020-04-23T17:45:00.000Z' }),
    IsISO8601({ strict: true }, { always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", String)
], ListOrderRequestDto.prototype, "startDate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date, description: 'Orders before date (UTC date)', example: '2020-04-24T18:35:00.000Z' }),
    IsISO8601({ strict: true }, { always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", String)
], ListOrderRequestDto.prototype, "endDate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object, description: 'Sorting rules', example: { uuid: 'ASC' } }),
    IsObject({ always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Object)
], ListOrderRequestDto.prototype, "sort", void 0);
//# sourceMappingURL=ListOrderRequestDto.js.map